<template>
  <div>
    <el-submenu :index="menuInfo.url" :class="`level${level}`">
      <template slot="title">
        <!-- <i :class="menuInfo.icon"></i> -->
        <template v-if="menuInfo.icon">
          <i :class="menuInfo.icon" v-if="menuInfo.icon.startsWith('el-')"></i>
          <div
            class="custom_icon"
            :class="`${menuInfo.icon}${
              menuInfo.url == currentLevel1 ? '_s' : ''
            }`"
            v-else
          ></div
        ></template>
        <span>{{ menuInfo.name }}</span>
      </template>

      <div v-for="item in menuInfo.children" :key="item.id">
        <el-menu-item
          v-if="!item.children || item.children.length == 0"
          :index="item.url"
          :class="`level${level + 1}`"
        >
          <template v-if="item.icon">
            <i :class="item.icon" v-if="item.icon.startsWith('el-')"></i>
            <div class="custom_icon" :class="item.icon" v-else></div
          ></template>
          <span slot="title">{{ item.name }}</span>
        </el-menu-item>
        <Submenu v-else :menuInfo="item" :level="level + 1" />
      </div>
    </el-submenu>
  </div>
</template>

<script>
export default {
  name: "Submenu", //组件递归调用
  props: {
    menuInfo: {
      type: Object,
      default: () => {},
    },
    //当前菜单等级
    level: {
      type: Number,
    },
    currentLevel1: {
      type: String,
    },
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.custom_icon {
  display: inline-block;
  margin-right: 5px;
  width: 18px;
  height: 18px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
</style>
